const UNSIGNED_STATUSES = new Set([
  'draft',
  'scoping',
  'in-negotiation',
  'in negotiation',
  'planning',
  'proposed',
])

const SIGNED_STATUSES = new Set([
  'in-progress',
  'in progress',
  'active',
  'launching',
  'on-hold',
  'on hold',
  'complete',
  'closed',
])

const normalize = (value) => String(value || '').trim().toLowerCase()

const isFiniteNumber = (value) => {
  if (value === null || value === undefined || value === '') return false
  const parsed = Number(value)
  return Number.isFinite(parsed)
}

const hasStatementOfWorkDoc = (docs) => {
  if (!Array.isArray(docs)) return false
  return docs.some((doc) => {
    const title = normalize(doc?.title)
    const url = normalize(doc?.url)
    return title.includes('statement of work')
      || title.includes('sow')
      || url.includes('statement-of-work')
      || url.includes('/sow')
  })
}

const isRetainerContract = ({ contractType, contractBillingType }) => {
  const joined = `${normalize(contractType)} ${normalize(contractBillingType)}`
  return joined.includes('retainer') || joined.includes('hourly')
}

const isUnsignedStatus = (status) => UNSIGNED_STATUSES.has(normalize(status))
const isSignedStatus = (status) => SIGNED_STATUSES.has(normalize(status))

export const validateEngagementLifecycleTransition = ({
  previousStatus,
  nextStatus,
  billingCode,
  projectCode,
  estimatedProjectValue,
  docs,
  contractType,
  contractBillingType,
}) => {
  const errors = []

  if (projectCode && !billingCode) {
    errors.push('Billing Code is required when Project Code is set.')
  }

  const isSigningTransition = isUnsignedStatus(previousStatus) && isSignedStatus(nextStatus)
  if (!isSigningTransition) {
    return { isValid: errors.length === 0, errors }
  }

  if (!billingCode) {
    errors.push('Billing Code is required when moving from unsigned to signed status.')
  }

  if (!isFiniteNumber(estimatedProjectValue)) {
    errors.push('Estimated Value is required when moving from unsigned to signed status.')
  }

  if (!isRetainerContract({ contractType, contractBillingType }) && !hasStatementOfWorkDoc(docs)) {
    errors.push('Statement of Work document is required for non-retainer engagements when moving to signed status.')
  }

  return {
    isValid: errors.length === 0,
    errors,
  }
}

export default validateEngagementLifecycleTransition
